 
import api from '../../interceptorServices';
import base_url from '../../../config';
const path = base_url+'api/management/dashboardAccommodation';
const seriesTypeUrl = base_url+'api/admin/esSeriesType';
const mgmtAccommodationUrl = base_url+'api/management/mgmtAccommodation';
const conferenceEventUrl = base_url+'api/admin/conferenceEvent';
const revenueUrl = base_url+'api/management/dashboardRevenue';
const countryUrl = base_url+'api/management/dashboardRevenueByCountry';

export const getData = async (params) => {
  const whereParam = params;
  const response = await api.post(path, whereParam);
  return response.data.data;
};

export const addData = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const updateData = async (data) => {
  const response = await api.put(path, data);
  return response.data;
};

export const deleteData = async (data) => {
  const response = await api.delete(path, {
    data: { id: data.id },
  });
  return response.data;
};

export const getSeriesType = async () => {
  const response = await api.get(seriesTypeUrl);
  return response.data.data;
};

export const getmgmtAccommodation = async () => {
  const response = await api.get(mgmtAccommodationUrl);
  return response.data.data;
};

export const getconferenceEvent = async () => {
  const response = await api.get(conferenceEventUrl);
  return response.data.data;
};

export const getRevenueData = async (params) => {
  const response = await api.post(revenueUrl,params);
  return response.data.data;
};

export const getRevenueByCountry = async (params) => {
  const response = await api.post(countryUrl,params);
  return response.data.data;
};

 